import React from "react";
import { t } from "../../../../../utils/i18n";

const tokenMap = {
  USDT: "USD"
};

const Header = ({
  step = "selectTrade",
  tradeType = "Buy",
  token = "USDT"
}) => (
  <div className="header createoffer-step-progress-bar">
    <div className="createoffer-progress-bar-steps-cont">
    <span className={`createoffer-progress-bar-steps ${step === "selectTrade" || step === "pricing" || step === "settings" ? "createoffer-activestep" : "createoffer-inactivestep"}`}>
      {step === "pricing" || step === "settings" ? (<i class="fa-solid fa-circle-check"></i>) : (<i className="material-icons">adjust</i> )}
        <span>{t("p2p.header.step1")}</span>
      </span>
      <hr className={`createoffer-progress-bar-line ${step === "pricing" || step === "settings" ? "createoffer-activeline" : "createoffer-inactiveline"}`}/>
      <span className={`createoffer-progress-bar-steps ${step === "pricing" || step === "settings" ? "createoffer-activestep" : "createoffer-inactivestep"}`}>
      {step === "settings" ? (<i class="fa-solid fa-circle-check"></i>) : (<i className="material-icons">adjust</i> )}
        <span>{t("p2p.header.step2")}</span>
      </span>
      <hr className={`createoffer-progress-bar-line ${step === "settings" ? "createoffer-activeline" : "createoffer-inactiveline"}`}/>
      <span className={`createoffer-progress-bar-steps ${step === "settings" ? "createoffer-activestep" : "createoffer-inactivestep"}`}>
        <i className="material-icons">adjust</i> {t("p2p.header.step3")}
      </span>
    </div>
  </div>
);

export default Header;
